<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import PageHeader from "@/components/page-header";

import "vue3-treeselect/dist/vue3-treeselect.css";
import BirimSecimi from "./birimsecimi.vue";
import Multiselect from 'vue-multiselect'

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Hoşgeldiniz",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    BirimSecimi, Multiselect
  },
  data() {
    return {
      title: "Birim Rolleri",
      items: [
        {
          text: "Birim Rolleri",
          href: "/",
        },
        {
          text: "Yetki İşlemleri",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      //Kullanicilar: {},
      KullanicilarTable: {},
      Ouygulama: {},
      KullaniciRolleri: {},
      KullaniciAra: null,
      BirimAra: null,
      SeciliKullaniciYetkileri: {},
      SeciliYetkiKullaniciliari: {},
      Roles: [],
      KullanicilarArray: [],
      BirimArray: [],
      Tab: 1,
    };
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  methods: {
    onSearchChange(name) {
      if (name.length > 2) {
        this.kullanici_yukle(name);
      }
    },


    Get() {
      this.KullaniciRolleri = [];
      this.KullanicilarArray = [];


      this.ActionsGet({
        Service: "obirim",
        FullData: true,
      }).then((res) => {
        for (let i = 0; i < res.Data.length; i++) {
          this.BirimArray.push({
            id: res.Data[i].Id,
            label: res.Data[i].Birimadi,
          });
        }
      });


    },

    kullanici_yukle(name) {

      if (name.length > 2) {
        this.KullanicilarArray = [];
        let Page = {
          PageNumber: "1",
          PageSize: "50",
        };
        let Filter = "&name=" + name
        this.ActionsFilterGet({
          Service: JSON.parse(localStorage.getItem("config")).API_ACCOUNT_URL + "Account/get-users",
          Page: Page,
          Filter: Filter
        }).then((res) => {

          for (let i = 0; i < res.Data.length; i++) {
            this.KullanicilarArray.push({
              id: res.Data[i].Id,
              label: res.Data[i].FirstName + " " + res.Data[i].LastName + "  /" + res.Data[i].Email,
            });
          }
        });
      }

    },

    YetkiKullaniciSorgu(BirimId) {
      this.ActionsFilterGet({
        Service: "ouserbirimyetki",
        Page: this.PageToplu,
        Filter: "&Birimid=" + BirimId.id,
      }).then((res) => {
        this.SeciliYetkiKullaniciliari = res.Data;
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="card-body">
            <h5 class="h4 card-title">
              {{ $t("userroles.page.yetkiislemleri") }}
            </h5>
            <p class="card-title-desc">
              {{
                $t(
                  "userroles.page.kullanicilaricinyetkinedirmeveyetkilistelemeekrani"
                )
              }}
            </p>

            <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
              <b-tab active @click="Tab = 1">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("userroles.page.kullaniciyetkilendirme")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.kullaniciara") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkilendirmekistediginizkullaniciyiseciniz"
                      )
                    }}
                  </p>
                  <div class="col-lg-12">
                    <multiselect v-model="KullaniciAra" :options="KullanicilarArray" :searchable="true"
                      :placeholder="'Kullanıcı Ara...'" label="label" track-by="id" @search-change="onSearchChange"
                      :deselect-label="'Seçimi kaldır'" :selected-label="'Seçildi'" :select-label="'Seç'" />

                  </div>


                </div>
              </b-tab>

              <b-tab @click="Tab = 2">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("userroles.page.birimlistele")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.birimler") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.birimebaglikullanicilarigormekcinsecimyapin"
                      )
                    }}
                  </p>
                  <div class="col-lg-12">


                    <multiselect v-model="BirimAra" :options="BirimArray" :searchable="true"
                      :placeholder="'Kullanıcı Ara...'" label="label" track-by="id"
                      @select="YetkiKullaniciSorgu($event)" :deselect-label="'Seçimi kaldır'"
                      :selected-label="'Seçildi'" :select-label="'Seç'" />
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="KullaniciAra && Tab == 1">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ this.$t("userroles.page.kullaniciyetkilendirmeekrani") }}
          </h5>
          <p class="card-title-desc">
            {{ this.$t("userroles.page.ekampusicin") }}
            {{ this.$t("userroles.page.yetkilendirmeekrani") }}
          </p>

          <div class="row">
            <div class="col-lg-12">
              <div class="mt-4 mt-lg-0 mb-3" style="height:300px">
                <BirimSecimi v-if="KullaniciAra" :Userid="KullaniciAra.id" title="Talep Yönetim Sistemi" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="BirimAra && Tab == 2">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </h5>
          <p class="card-title-desc">
            {{ $t("userroles.page.listelenenyetki") }}
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </p>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t("userroles.table.FirstName") }}</th>
                  <th scope="col">{{ $t("userroles.table.LastName") }}</th>
                  <th scope="col">{{ $t("userroles.table.Email") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(Kullanici, index) in SeciliYetkiKullaniciliari" :key="index">
                  <td>{{ Kullanici.Adi }}</td>
                  <td>{{ Kullanici.Soyadi }}</td>
                  <td>{{ Kullanici.Mail }}</td>
                </tr>
              </tbody>
            </table>
            <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
              :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"   
                  :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
              @input="ChangePage(DefaultPage)">
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
